import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api } from "common";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";
import { Modal, Grid, Typography, MenuItem, Button } from "@mui/material";
// import Button from "components/CustomButtons/Button.js";
import CancelIcon from "@mui/icons-material/Cancel";
import AlertDialog from "../components/AlertDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import moment from "moment/min/moment-with-locales";
import "../styles/style.css";
import * as yup from "yup";
import Loader from "components/Loader";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  submit3: {
    width: "100%",
    borderRadius: 3,
    marginTop: 2,
    padding: 4,
  },
  paper: {
    width: 500,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 15,
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function CarsList() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const settings = useSelector((state) => state.settingsdata.settings);
  const userdata = useSelector((state) => state.usersdata);
  const auth = useSelector((state) => state.auth);
  const [drivers, setDrivers] = useState([]);
  const { updateUserCar, editCar, uploadImage } = api;
  const [driversObj, setDriversObj] = useState();
  const [fleetMapObj, setFleetMapObj] = useState([]);
  const [data, setData] = useState([]);
  const cartypes = useSelector((state) => state.cartypes);
  const carlistdata = useSelector((state) => state.carlistdata);
  const dispatch = useDispatch();
  const rootRef = useRef(null);
  const classes = useStyles();
  const [cars, setCars] = useState({});
  const [carz, setCarsArr] = useState([]);

  const [role, setRole] = useState(null);
  const [addRowModalOpen, setAddRowModalOpen] = useState(false);
  const [editing, setediting] = useState(false);
  const [oldData, setOlddata] = useState("");
  const [loader, setloader] = useState(false);
  
  const handleAssignDriver =()=>{
    const   query=   new URLSearchParams(window.location.search)
    console.log(query,"query")
    const assigndriver =query.get("assigncar")
    console.log(assigndriver,"outside")

    if(assigndriver&&assigndriver=="true"){
      console.log(assigndriver,"inside")
      setAddRowModalOpen(true)
    }
  }
  useEffect(()=>{
    handleAssignDriver()
  },[])
  const handleAddrow = (newData) => {
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve, reject) => {
          setTimeout(() => {
            if (
              newData &&
              newData.carType &&
              newData.vehicleNumber &&
              newData.vehicleMake &&
              newData.vehicleModel &&
              newData.other_info &&
              newData.car_image
            ) {
              let selectDriver =
                role === "admin" ? newData.driver : auth.profile.uid;
              let activeCar = null;
              let updateData = {
                carType: newData.carType,
                vehicleNumber: newData.vehicleNumber,
                vehicleMake: newData.vehicleMake,
                vehicleModel: newData.vehicleModel,
                other_info: newData.other_info,
                car_image: newData.car_image,
                updateAt: new Date().getTime(),
              };
              for (let i = 0; i < data.length; i++) {
                if (data[i].driver === newData.driver && data[i].active) {
                  activeCar = data[i];
                  break;
                }
              }
              if (activeCar && newData.active) {
                activeCar.active = false;
                dispatch(editCar(activeCar, "Update"));
                dispatch(updateUserCar(selectDriver, updateData));
              } else if (activeCar && !newData.active) {
                newData.active = false;
              } else {
                newData.active = true;
                dispatch(updateUserCar(selectDriver, updateData));
              }
              if (role === "driver") {
                newData["driver"] = selectDriver;
              }
              newData["createdAt"] = new Date().getTime();
              newData["fleetadmin"] = newData["driver"]
                ? fleetMapObj[newData["driver"]]
                  ? fleetMapObj[newData["driver"]]
                  : null
                : null;
              if (!settings.carApproval) {
                newData["approved"] = true;
                if (newData.active) {
                  dispatch(
                    updateUserCar(newData.driver, { carApproved: true })
                  );
                }
              } else {
                newData["approved"] = false;
              }
              dispatch(editCar(newData, "Add"));
              resolve();
            } else {
              alert(t("proper_input_name"));
              reject();
            }
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleUpdateRow = (newData, oldData) => {
    newData.id = oldData.id;
    settings.AllowCriticalEditsAdmin
      ? new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            if (newData !== oldData) {
              let activeCar = null;
              let updateData = {
                carType: newData.carType,
                vehicleNumber: newData.vehicleNumber,
                vehicleMake: newData.vehicleMake,
                vehicleModel: newData.vehicleModel,
                other_info: newData.other_info,
                car_image: newData.car_image,
                updateAt: new Date().getTime(),
              };
              for (let i = 0; i < data.length; i++) {
                if (data[i].driver === newData.driver && data[i].active) {
                  activeCar = data[i];
                  break;
                }
              }
              if (activeCar && newData.active) {
                activeCar.active = false;
                dispatch(editCar(activeCar, "Update"));
                dispatch(updateUserCar(newData.driver, updateData));
              } else if (activeCar && !newData.active) {
                newData.active = false;
              } else {
                newData.active = true;
                dispatch(updateUserCar(newData.driver, updateData));
              }
              newData["fleetadmin"] = newData["fleetadmin"]
                ? fleetMapObj[newData["driver"]]
                : null;
              delete newData.tableData;
              dispatch(editCar(newData, "Update"));
              if (newData.driver !== oldData.driver && oldData.driver) {
                dispatch(
                  updateUserCar(oldData.driver, {
                    carType: null,
                    vehicleNumber: null,
                    vehicleMake: null,
                    vehicleModel: null,
                    other_info: null,
                    car_image: null,
                    updateAt: new Date().getTime(),
                  })
                );
              }
            }
          }, 600);
        })
      : new Promise((resolve) => {
          setTimeout(() => {
            resolve();
            alert(t("demo_mode"));
          }, 600);
        });
  };
  const handleOpenAddRowModal = (data) => {
    setAddRowModalOpen(true);
  };

  const handleCloseModal = () => {
    setAddRowModalOpen(false);
  };

  useEffect(() => {
    if (role !== "driver" && userdata.users) {
      let arr = userdata.users.filter(
        (user) =>
          user.usertype === "driver" &&
          ((role === "fleetadmin" &&
            user.fleetadmin &&
            user.fleetadmin === auth.profile.uid) ||
            role === "admin")
      );
      let obj = {};
      let obj2 = {};
      let arr2 = [];
      for (let i = 0; i < arr.length; i++) {
        let user = arr[i];
        arr2.push({
          id: user.id,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
            ") " +
            (settings.AllowCriticalEditsAdmin ? user.email : "Hidden"),
        });
        obj[user.id] =
          user.firstName +
          " " +
          user.lastName +
          " (" +
          (settings.AllowCriticalEditsAdmin ? user.mobile : "Hidden") +
          ") " +
          (settings.AllowCriticalEditsAdmin ? user.email : "Hidden");
        obj2[user.id] = user.fleetadmin ? user.fleetadmin : null;
      }
      setDrivers(arr2);
      setDriversObj(obj);
      setFleetMapObj(obj2);
    }
  }, [
    userdata.users,
    settings.AllowCriticalEditsAdmin,
    role,
    auth.profile.uid,
  ]);

  useEffect(() => {
    if (cartypes.cars) {
      let obj = {};
      cartypes.cars
        .sort((a, b) => a.pos - b.pos)
        .map((car) => (obj[car.name] = car.name));
      setCars(obj);
    }
    setCarsArr(cartypes?.cars);
    // console.log(, "carz");
  }, [cartypes.cars]);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

  useEffect(() => {
    if (carlistdata.cars) {
      setData(carlistdata.cars);
    } else {
      setData([]);
    }
  }, [carlistdata.cars]);

  const [selectedImage, setSelectedImage] = useState(null);
  const handleProfileModal = (e) => {
    setProfileModal(false);
    setSelectedImage(null);
  };

  const [userData, setUserData] = useState();
  const [profileModal, setProfileModal] = useState(false);
  const [imageData, setImageData] = useState(false);
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState(false);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };

  const handleSetProfileModal = (e) => {
    e.preventDefault();
    if (selectedImage) {
      setLoading(true);
      let finalData = userData;
      finalData.car_image = selectedImage;
      dispatch(editCar(finalData, "UpdateImage"));
      setProfileModal(false);
      setTimeout(() => {
        setSelectedImage(null);
        setLoading(false);
      }, 10000);
    } else {
      setCommonAlert({ open: true, msg: t("choose_image_first") });
    }
  };

  const onClick = (rowData) => {
    setImageData(rowData.car_image);
    setProfileModal(true);
    setUserData(rowData);
  };

  const columns = [
    {
      title: t("createdAt"),
      field: "createdAt",
      editable: "never",
      defaultSort: "desc",
      render: (rowData) =>
        rowData.createdAt ? moment(rowData.createdAt).format("lll") : null,
      cellStyle: { textAlign: isRTL === "rtl" ? "right" : "center" },
    },
    {
      title: t("driver"),
      field: "driver",
      editable: role === "driver" ? "never" : "always",
      cellStyle: { textAlign: "center" },
      render: (rowData) => {
        if (rowData && rowData.driver) {
          return driversObj && driversObj[rowData.driver]
            ? driversObj[rowData.driver]
            : null;
        }
      },
      editComponent: (props) => (
        <Autocomplete
          id="combo-box-demo"
          options={drivers}
          getOptionLabel={(option) => option.desc}
          style={{ width: 300 }}
          renderInput={(params) => (
            <TextField {...params} label="Combo box" variant="outlined" />
          )}
          onChange={(event, newValue) => {
            props.onChange(newValue.id);
          }}
        />
      ),
      exportTransformer: (rowData) => driversObj[rowData.driver],
      hidden: role === "driver" ? true : false,
    },
    { title: t("car_type"), field: "carType", lookup: cars },
    { title: t("vehicle_reg_no"), field: "vehicleNumber" },
    { title: t("vehicle_model_name"), field: "vehicleMake" },
    { title: t("vehicle_model_no"), field: "vehicleModel" },
    { title: t("other_info"), field: "other_info" },
    {
      title: t("image"),
      field: "car_image",
      initialEditValue:
        "https://cdn.pixabay.com/photo/2012/04/13/20/37/car-33556__480.png",
      render: (rowData) =>
        rowData.car_image ? (
          <button
            onClick={() => {
              onClick(rowData);
            }}
          >
            <img alt="CarImage" src={rowData.car_image} style={{ width: 50 }} />
          </button>
        ) : null,
    },
    {
      title: t("active_status"),
      field: "active",
      editable: role === "admin" ? "never" : "always",
      type: "boolean",
    },
    {
      title: t("approved"),
      field: "approved",
      editable: "never",
      type: "boolean",
    },
  ];


  return carlistdata.loading ? (
    <CircularLoading />
  ) : (
    <div ref={rootRef}>
      <MaterialTable
        // title={t('cars')}
        title={<span className="tableTitleStyle">{t("cars")}</span>}
        columns={columns}
        style={{
          direction: isRTL === "rtl" ? "rtl" : "ltr",
          borderRadius: "20px",
          marginTop: 20,
          boxShadow: "rgba(0, 0, 0, 0.1) 0px -0.4rem 3rem",
        }}
        data={data}
        // onRowClick={(evt, selectedRow) =>
        //   setSelectedRow(selectedRow.tableData.id)
        // }
        options={{
          exportButton: true,
          rowStyle: (rowData) => ({
            fontSize: "12px",
            // backgroundColor:
            //   selectedRow === rowData.tableData.id ? "#EEE" : "#FFF",
          }),
          editable: {
            fontSize: "12px",
            fontWeight: "bold ",
            // backgroundColor: colors.Header_Text,
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
          headerStyle: {
            position: "sticky",
            top: "0px",
            backgroundColor: "#e1e7f0",
            color: "#000",
            fontSize: "12px",
            fontWeight: "bold ",
            // backgroundColor: colors.Header_Text_back,
            // color: "#fff",
            // fontSize: "0.8em",
            // fontWeight: "bold ",
            // fontFamily: 'Lucida Console", "Courier New", monospace',
          },
        }}
        localization={{
          body: {
            addTooltip: t("add"),
            deleteTooltip: t("delete"),
            editTooltip: t("edit"),
            emptyDataSourceMessage: t("blank_message"),
            editRow: {
              deleteText: t("delete_message"),
              cancelTooltip: t("cancel"),
              saveTooltip: t("save"),
            },
          },
          toolbar: {
            searchPlaceholder: t("search"),
            exportTitle: t("export"),
          },
          header: {
            actions: t("actions"),
          },
          pagination: {
            labelDisplayedRows: "{from}-{to} " + t("of") + " {count}",
            firstTooltip: t("first_page_tooltip"),
            previousTooltip: t("previous_page_tooltip"),
            nextTooltip: t("next_page_tooltip"),
            lastTooltip: t("last_page_tooltip"),
          },
        }}
        actions={[
          {
            icon: "edit",
            onClick: (event, rowData) => {
              // Do save operation
              setediting(true);
              setOlddata(rowData);
              handleOpenAddRowModal();
            },
          },
          {
            icon: "add",
            tooltip: "Add Row",
            isFreeAction: true,
            onClick: handleOpenAddRowModal,
          },
        ]}
        editable={{
          // onRowAdd: (newData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve, reject) => {
          //         console.log(newData, "newDatanewData");

          //         setTimeout(() => {
          //           if (
          //             newData &&
          //             newData.carType &&
          //             newData.vehicleNumber &&
          //             newData.vehicleMake &&
          //             newData.vehicleModel &&
          //             newData.other_info &&
          //             newData.car_image
          //           ) {
          //             let selectDriver =
          //               role === "admin" ? newData.driver : auth.profile.uid;
          //             let activeCar = null;
          //             let updateData = {
          //               carType: newData.carType,
          //               vehicleNumber: newData.vehicleNumber,
          //               vehicleMake: newData.vehicleMake,
          //               vehicleModel: newData.vehicleModel,
          //               other_info: newData.other_info,
          //               car_image: newData.car_image,
          //               updateAt: new Date().getTime(),
          //             };
          //             for (let i = 0; i < data.length; i++) {
          //               if (
          //                 data[i].driver === newData.driver &&
          //                 data[i].active
          //               ) {
          //                 activeCar = data[i];
          //                 break;
          //               }
          //             }
          //             if (activeCar && newData.active) {
          //               activeCar.active = false;
          //               dispatch(editCar(activeCar, "Update"));
          //               dispatch(updateUserCar(selectDriver, updateData));
          //             } else if (activeCar && !newData.active) {
          //               newData.active = false;
          //             } else {
          //               newData.active = true;
          //               dispatch(updateUserCar(selectDriver, updateData));
          //             }
          //             if (role === "driver") {
          //               newData["driver"] = selectDriver;
          //             }
          //             newData["createdAt"] = new Date().getTime();
          //             newData["fleetadmin"] = newData["driver"]
          //               ? fleetMapObj[newData["driver"]]
          //                 ? fleetMapObj[newData["driver"]]
          //                 : null
          //               : null;
          //             if (!settings.carApproval) {
          //               newData["approved"] = true;
          //               if (newData.active) {
          //                 dispatch(
          //                   updateUserCar(newData.driver, { carApproved: true })
          //                 );
          //               }
          //             } else {
          //               newData["approved"] = false;
          //             }
          //             dispatch(editCar(newData, "Add"));
          //             resolve();
          //           } else {
          //             alert(t("proper_input_name"));
          //             reject();
          //           }
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          // onRowUpdate: (newData, oldData) =>
          //   settings.AllowCriticalEditsAdmin
          //     ? new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           if (newData !== oldData) {
          //             let activeCar = null;
          //             let updateData = {
          //               carType: newData.carType,
          //               vehicleNumber: newData.vehicleNumber,
          //               vehicleMake: newData.vehicleMake,
          //               vehicleModel: newData.vehicleModel,
          //               other_info: newData.other_info,
          //               car_image: newData.car_image,
          //               updateAt: new Date().getTime(),
          //             };
          //             for (let i = 0; i < data.length; i++) {
          //               if (
          //                 data[i].driver === newData.driver &&
          //                 data[i].active
          //               ) {
          //                 activeCar = data[i];
          //                 break;
          //               }
          //             }
          //             if (activeCar && newData.active) {
          //               activeCar.active = false;
          //               dispatch(editCar(activeCar, "Update"));
          //               dispatch(updateUserCar(newData.driver, updateData));
          //             } else if (activeCar && !newData.active) {
          //               newData.active = false;
          //             } else {
          //               newData.active = true;
          //               dispatch(updateUserCar(newData.driver, updateData));
          //             }
          //             newData["fleetadmin"] = newData["fleetadmin"]
          //               ? fleetMapObj[newData["driver"]]
          //               : null;
          //             delete newData.tableData;
          //             dispatch(editCar(newData, "Update"));
          //             if (newData.driver !== oldData.driver && oldData.driver) {
          //               dispatch(
          //                 updateUserCar(oldData.driver, {
          //                   carType: null,
          //                   vehicleNumber: null,
          //                   vehicleMake: null,
          //                   vehicleModel: null,
          //                   other_info: null,
          //                   car_image: null,
          //                   updateAt: new Date().getTime(),
          //                 })
          //               );
          //             }
          //           }
          //         }, 600);
          //       })
          //     : new Promise((resolve) => {
          //         setTimeout(() => {
          //           resolve();
          //           alert(t("demo_mode"));
          //         }, 600);
          //       }),
          onRowDelete: (oldData) =>
            settings.AllowCriticalEditsAdmin
              ? new Promise((resolve, reject) => {
                  setTimeout(() => {
                    if (oldData.active) {
                      reject();
                      alert(t("active_car_delete"));
                    } else {
                      resolve();
                      dispatch(editCar(oldData, "Delete"));
                    }
                  }, 600);
                })
              : new Promise((resolve) => {
                  setTimeout(() => {
                    resolve();
                    alert(t("demo_mode"));
                  }, 600);
                }),
        }}
        // actions={[
        //   (rowData) =>
        //     settings.carApproval && role === "admin"
        //       ? {
        //           icon: () =>
        //             rowData.approved ? (
        //               <div
        //                 style={{
        //                   display: "flex",
        //                   alignItems: "center",
        //                   flexWrap: "wrap",
        //                 }}
        //               >
        //                 <BlockIcon />
        //                 <Typography variant="subtitle2">
        //                   {t("reject")}
        //                 </Typography>
        //               </div>
        //             ) : (
        //               <div
        //                 style={{
        //                   display: "flex",
        //                   alignItems: "center",
        //                   flexWrap: "wrap",
        //                 }}
        //               >
        //                 <DoneAllIcon />
        //                 <Typography variant="subtitle2">
        //                   {t("accept")}
        //                 </Typography>
        //               </div>
        //             ),
        //           onClick: (event, rowData) => {
        //             if (rowData.active) {
        //               dispatch(
        //                 updateUserCar(rowData.driver, {
        //                   carApproved: !rowData.approved,
        //                 })
        //               );
        //             }
        //             dispatch(
        //               editCar(
        //                 { ...rowData, approved: !rowData.approved },
        //                 "Update"
        //               )
        //             );
        //           },
        //         }
        //       : null,
        // ]}
      />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={profileModal}
        onClose={handleProfileModal}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid
          container
          spacing={1}
          className={classes.paper}
          style={{ direction: isRTL === "rtl" ? "rtl" : "ltr" }}
        >
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Typography component="h1" variant="h6">
              {t("car_image")}
              <input
                type="file"
                style={{ marginLeft: 10 }}
                name={t("image")}
                onChange={(event) => {
                  setSelectedImage(event.target.files[0]);
                }}
              />
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage && !loading ? (
              <Tooltip title={t("cancel")}>
                <CancelIcon
                  onClick={() => setSelectedImage(null)}
                  style={{
                    fontSize: 30,
                    backgroundColor: "red",
                    borderRadius: 50,
                    color: "white",
                  }}
                />
              </Tooltip>
            ) : null}
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {selectedImage ? (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={URL.createObjectURL(selectedImage)}
                style={{ marginTop: 15, marginBottom: 20 }}
              />
            ) : (
              <img
                alt="not fount"
                width={"200px"}
                height={"200px"}
                src={imageData}
                style={{ marginTop: 10 }}
              />
            )}
            <br />
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
          >
            {loading ? (
              <Grid
                container
                spacing={0}
                alignItems="center"
                justify="center"
                style={{ minHeight: "5vh" }}
              >
                <CircularProgress />
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: isRTL === "rtl" ? "right" : "left" }}
              >
                <Button
                  onClick={handleProfileModal}
                  variant="contained"
                  // color="danger"
                >
                  {t("cancel")}
                </Button>
                <Button
                  onClick={handleSetProfileModal}
                  variant="contained"
                  color="secondary"
                  style={{ marginLeft: 10 }}
                >
                  {t("save")}
                </Button>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Modal>
      {loader ? <Loader /> : null}

      <AddCARModel
        open={addRowModalOpen}
        onClose={handleCloseModal}
        handleAddRow={handleAddrow}
        oldData={oldData}
        editing={editing}
        setediting={setediting}
        handleUpdateRow={handleUpdateRow}
        drivers={drivers}
        carz={carz}
        setOlddata={setOlddata}
        uploadImage={uploadImage}
        setloader={setloader}
      />
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
    </div>
  );
}

const AddCARModel = ({
  open,
  onClose,
  handleAddRow,
  editing,
  oldData,
  carz,
  setediting,
  handleUpdateRow,
  drivers,
  setOlddata,
  uploadImage,
  setloader,
}) => {
  const [driver, setDriver] = useState("");
  const [vehicleType, setVehicleType] = useState("");
  const [vehicleRegistrationNumber, setVehicleRegistrationNumber] =
    useState("");
  const [otherInfo, setOtherInfo] = useState("");
  const [images, setImages] = useState("");
  const [vehicleModelNo, setVehicleModelNo] = useState("");
  const [errors, setErrors] = useState({});
  const [carBrand, setBrandcar] = useState("");
  const [frontimg, setimg] = useState("");
  const [frontBlob, setfrontBlob] = useState("");
  const [isThereAnyImage, setAnyImage] = useState();
  const schema = yup.object().shape({
    driver: yup.string().required("Driver is required"),
    vehicleType: yup.string().required("Vehicle type is required"),
    vehicleRegistrationNumber: yup
      .string()
      .required("Vehicle Registration Number is required"),
    carBrand: yup.string().required("Brand name is required"),
    otherInfo: yup.string().required("Information is required"),
    vehicleModelNo: yup.string().required("Model number is required"),
    // Add validation schema for other fields here
  });

  const validateForm = async () => {
    try {
      await schema.validate(
        {
          driver,
          vehicleType,
          vehicleRegistrationNumber,
          carBrand,
          otherInfo,
          vehicleModelNo,
          // Add other fields to be validated here
        },
        { abortEarly: false }
      );
      setErrors({});
      return true;
    } catch (validationErrors) {
      const errorsMap = {};
      validationErrors.inner.forEach((error) => {
        errorsMap[error.path] = error.message;
      });
      setErrors(errorsMap);
      return false;
    }
  };

  useEffect(() => {
    if (oldData) {
      setDriver(oldData?.driver || "");
      setVehicleType(oldData?.carType || "");
      setVehicleRegistrationNumber(oldData?.vehicleNumber || "");
      setOtherInfo(oldData?.other_info || "");
      setImages(oldData?.car_image || "");
      setVehicleModelNo(oldData?.vehicleModel || "");
      setBrandcar(oldData?.vehicleMake || "");
      setimg(oldData?.car_image || "");
      setAnyImage(oldData?.car_image || "");
    }
  }, [oldData]);

  const handleAddCar = async () => {
    let image;
    if (frontBlob) {
      setloader(true);
      image = await uploadImage(frontBlob);
      setloader(false);
    }
    const isValid = await validateForm();
    if (!isValid) return;

    // Perform your logic to add/update the car here
    setAnyImage(image ? image : images);
    const carData = {
      driver,
      carType: vehicleType,
      vehicleNumber: vehicleRegistrationNumber,
      other_info: otherInfo,
      car_image: image ? image : images,
      vehicleModel: vehicleModelNo,
      createdAt: new Date().toISOString(),
      vehicleMake: carBrand,
      active: false,
      approved: true,
    };

    setloader(true);
    if (editing) {
      handleUpdateRow(carData, oldData);
    } else {
      handleAddRow(carData);
    }
    setloader(false);

    setediting(false);

    // Reset the form
    setDriver("");
    setVehicleType("");
    setVehicleRegistrationNumber("");
    setOtherInfo("");
    setImages("");
    setVehicleModelNo("");
    setBrandcar("");
    setErrors("");
    setOlddata("");
    setimg("");
    setAnyImage("");

    // Close the modal
    onClose();
  };

  const handleClose = () => {
    // Reset the form
    setDriver("");
    setVehicleType("");
    setVehicleRegistrationNumber("");
    setOtherInfo("");
    setImages("");
    setVehicleModelNo("");
    setediting(false);
    setBrandcar("");
    setErrors("");
    setOlddata("");
    setimg("");
    // Close the modal
    setAnyImage("");
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div
        className="modal-container"
        style={{
          backgroundColor: "white",
          width: "80%",
          margin: "auto",
          marginTop: "3vh",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          overflow: "scroll",
          maxHeight: "90vh", // Add max height for scrolling
          scrollbarWidth: "thin", // Width of the scrollbar
          scrollbarColor: "#888 #f1f1f1", // Color of the scrollbar thumb and track
        }}
      >
        <h2>{editing ? "Edit" : "Add"} Car</h2>
        <TextField
          select
          label="Driver"
          value={driver}
          onChange={(e) => setDriver(e.target.value)}
          error={errors.driver !== undefined}
          helperText={errors.driver}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        >
          <MenuItem value="">Select Driver</MenuItem>
          {/* Replace with your driver options */}
          {drivers?.map((itm, i) => {
            return (
              <MenuItem key={i} value={itm.id}>
                {itm.desc}
              </MenuItem>
            );
          })}
        </TextField>

        <TextField
          select
          label="Vehicle Type"
          value={vehicleType}
          onChange={(e) => setVehicleType(e.target.value)}
          error={errors.vehicleType !== undefined}
          helperText={errors.vehicleType}
          required
          style={{ width: "100%", marginBottom: "10px" }}
        >
          {/* drivers */}
          <MenuItem value="">Select Vehicle Type</MenuItem>
          {/* Replace with your vehicle type options */}
          {carz?.map((itm, i) => {
            return (
              <MenuItem key={i} value={itm.name}>
                {itm.name}
              </MenuItem>
            );
          })}
          {/* <MenuItem value="SUV">SUV</MenuItem>
          <MenuItem value="Truck">Truck</MenuItem> */}
        </TextField>

        <TextField
          label="Vehicle Registration Number"
          value={vehicleRegistrationNumber}
          error={errors.vehicleRegistrationNumber !== undefined}
          helperText={errors.vehicleRegistrationNumber}
          onChange={(e) => setVehicleRegistrationNumber(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        />

        <TextField
          label="Vehicle Make/Brand Name"
          value={carBrand}
          error={errors.carBrand !== undefined}
          helperText={errors.carBrand}
          onChange={(e) => setBrandcar(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <TextField
          label="Other Vehicle or Driver Info"
          value={otherInfo}
          error={errors.otherInfo !== undefined}
          helperText={errors.otherInfo}
          onChange={(e) => setOtherInfo(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        {/* 
        <TextField
          label="Images"
          value={images}
          onChange={(e) => setImages(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        /> */}

        <TextField
          label="Vehicle Model No"
          value={vehicleModelNo}
          error={errors.vehicleModelNo !== undefined}
          helperText={errors.vehicleModelNo}
          onChange={(e) => setVehicleModelNo(e.target.value)}
          style={{ width: "100%", marginBottom: "10px" }}
        />
        <div
          style={{ width: "100%", display: "flex", flexDirection: "column" }}
        >
          <label
            htmlFor="licenseFront"
            style={{
              color: "gray",
              fontSize: 13,
              marginBottom: 10,
              marginLeft: 20,
            }}
          >
            Image
          </label>
          <input
            accept="image"
            type="file"
            id="licenseFront"
            style={{
              padding: 10,
              // border: "1px solid gray",
              color: "gray",
              borderRadius: 12,
              opacity: 0.4,
            }}
            onChange={(e) => {
              setfrontBlob(e.target.files[0]);
              setAnyImage(e.target.files[0]);
              setimg(URL.createObjectURL(e.target.files[0]));
            }}
          />
        </div>
        {frontimg ? (
          <img
            src={frontimg}
            onClick={() => {
              setAnyImage("");
              setimg("");
            }}
            style={{
              width: 100,
              height: 110,
              border: "1px solid gray",
              borderRadius: 12,
            }}
            alt="frontimg"
          />
        ) : null}
        <div className="button-container" style={{ marginTop: "20px" }}>
          <Button
            variant="contained"
            onClick={handleAddCar}
            disabled={
              isThereAnyImage == "" ||
              isThereAnyImage == undefined ||
              isThereAnyImage == null
            }
            style={{
              backgroundColor: isThereAnyImage ? "darkblue" : "gray",
              color: "white",
            }}
          >
            {editing ? "Update" : "Add"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClose}
            style={{
              backgroundColor: "darkblue",
              color: "white",
              marginLeft: "10px",
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
